import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router';
import axios from 'axios'
import store from './store'
import ServerError from './components/Common/500'
import VueElementLoading from 'vue-element-loading'
Vue.component('VueElementLoading', VueElementLoading)

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);


import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);
Vue.component('ServerError', ServerError)

Vue.config.productionTip = false

axios.defaults.baseURL = 'http://65.0.180.156';
Vue.prototype.baseURL = "http://65.0.180.156"
Vue.prototype.mediaURL = "http://65.0.180.156/wp/"


Vue.mixin({
  data() {
    return {
      webpSupported: true,
    };
  },

  created() {
    (async () => {
      // If browser doesn't have createImageBitmap, we can't use webp.
      if (!self.createImageBitmap) {
        this.webpSupported = false;
        return;
      }
      // Base64 representation of a white point image
      const webpData =
        "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoCAAEAAQAcJaQAA3AA/v3AgAA=";
      // Retrieve the Image in Blob Format
      const blob = await fetch(webpData).then((r) => r.blob());
      // If the createImageBitmap method succeeds, return true, otherwise false
      this.webpSupported = await createImageBitmap(blob).then(
        () => true,
        () => false
      );
      if (this.webpSupported) {
        Vue.prototype.mediaURL = "http://65.0.180.156/wp/";
      } else {
        Vue.prototype.mediaURL = "http://65.0.180.156/u/";

      }
    })();
  },
});

new Vue({
  vuetify,
  router,
  store,


  render: h => h(App)
}).$mount('#app')
